var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 15.999,
    viewBox: "0 0 15.999 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2068.329 -262.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2083.775,267.113a5.067,5.067,0,0,0-.315-1.7,3.032,3.032,0,0,0-1.736-1.736,5.062,5.062,0,0,0-1.7-.315c-.965-.044-1.254-.053-3.7-.053s-2.732.009-3.7.053a5.062,5.062,0,0,0-1.7.315,3.029,3.029,0,0,0-1.736,1.736,5.066,5.066,0,0,0-.315,1.7c-.044.965-.053,1.254-.053,3.7s.009,2.732.053,3.7a5.065,5.065,0,0,0,.315,1.7,3.029,3.029,0,0,0,1.736,1.736,5.062,5.062,0,0,0,1.7.315c.965.044,1.254.053,3.7.053s2.732-.009,3.7-.053a5.062,5.062,0,0,0,1.7-.315,3.032,3.032,0,0,0,1.736-1.736,5.067,5.067,0,0,0,.315-1.7c.044-.965.053-1.254.053-3.7S2083.819,268.078,2083.775,267.113Zm-3.365.87a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,2080.41,267.983Z",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.049,
    cy: 3.049,
    r: 3.049,
    transform: "translate(2073.279 267.76)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fad24aae4a96107f0dc244622d1c7bc4.svg";
export { ForwardRef as ReactComponent };